const CSV_EXAMPLE_CONTENT = ['0000000', '1111111', '2222222'].join('\n');

export default function downloadCsvExample(): void {
  const blob = new Blob([CSV_EXAMPLE_CONTENT], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = 'exemplo.csv';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}
